import { z } from 'zod';

import type {
  approvePcfraInputSchema,
  pcfraActivityTypeSchema,
  pcfraDraftSchema,
  pcfraRecommendationSchema,
  pcfraReferrerSchema,
  pcfraValuesSchema,
  residentRepresentativeSchema,
  revokePcfraInputSchema,
  severitySchema,
} from '../schemas/pcfra';

import { DbRecord } from './db';
import { TableRow, UserStoreTables } from './tinybase';

export type PcfraDraft = z.infer<typeof pcfraDraftSchema>;

export type PcfraValues = z.infer<typeof pcfraValuesSchema>;

export type PcfraDraftValues = Subset<PcfraValues>;

export type PcfraDraftRecord = Override<DbRecord, PcfraDraft>;

export type CompletedPcfraDraftRecord = Override<PcfraDraft, { values: PcfraValues }>;

export type PcfraReferrer = z.infer<typeof pcfraReferrerSchema>;

export type PcfraReferrerRecord = DbRecord & PcfraReferrer;

export type PcfraRecommendation = z.infer<typeof pcfraRecommendationSchema>;

export type Severity = z.infer<typeof severitySchema>;

export type ApprovePcfraInput = z.infer<typeof approvePcfraInputSchema>;

export type RevokePcfraInput = z.infer<typeof revokePcfraInputSchema>;

export enum PcfraDocumentType {
  Pcfra = 'PCFRA',
  Rpeep = 'RPEEP',
}

export type PcfraDocument = TableRow<UserStoreTables, 'pcfraDocuments'>;

export type ActivePcfraDocumentMap = {
  personId: number;
  /** Property the PCFRA is associated with */
  documentPropertyId: number;
  documentId: number;
};

export type ActivePcfraDocumentMapRecord = DbRecord & ActivePcfraDocumentMap;

export type PcfraActivityType = z.infer<typeof pcfraActivityTypeSchema>;

export type ResidentRepresentative = z.infer<typeof residentRepresentativeSchema>;

export type RecommendedActionsReportItem = PcfraRecommendation & {
  personId: number;
  propertyId: number;
  personName: string;
  personAddress: string;
  pcfraApprovedDate: Date;
};
